var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { close: _vm.close, printButton: true, downloadButton: true } },
    [
      _c("span", { attrs: { slot: "modalHeader" }, slot: "modalHeader" }, [
        _vm._v("Сведения из реестра недобросовестных поставщиков"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "unfair-content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _vm.isActual
            ? _c("div", [
                _c("h2", { staticClass: "unfair-title" }, [
                  _vm._v("Актуальные сведения"),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "unfair-list" },
                  _vm._l(_vm.actualList, function (e) {
                    return _c("li", [
                      _vm._v(
                        "\n                    C " +
                          _vm._s(_vm.dateParser(e.unfair_date)) +
                          " контрагент включён в реестр недобросовестных поставщиков.\n                    Причина включения в реестр: " +
                          _vm._s(e.reason) +
                          " \n                    "
                      ),
                      e.guid_link
                        ? _c("span", [
                            _vm._v("("),
                            _c(
                              "a",
                              {
                                attrs: { href: e.guid_link, target: "_blank" },
                              },
                              [_vm._v("Закупка: " + _vm._s(e.purchase_number))]
                            ),
                            _vm._v(")"),
                          ])
                        : _c("span", [
                            _vm._v(
                              "(Закупка: " + _vm._s(e.purchase_number) + ")"
                            ),
                          ]),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isArchive
            ? _c("div", [
                _c("h2", { staticClass: "unfair-title" }, [
                  _vm._v(
                    "Архивные сведения (на данный момент по ним исключён из реестра)"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "unfair-list" },
                  _vm._l(_vm.archiveList, function (e) {
                    return _c("li", [
                      _vm._v(
                        "\n                    C " +
                          _vm._s(_vm.dateParser(e.unfair_date)) +
                          " контрагент был включён в реестр недобросовестных поставщиков.\n                    Причина включения в реестр: " +
                          _vm._s(e.reason) +
                          " \n                    "
                      ),
                      e.guid_link
                        ? _c("span", [
                            _vm._v("("),
                            _c(
                              "a",
                              {
                                attrs: { href: e.guid_link, target: "_blank" },
                              },
                              [_vm._v("Закупка: " + _vm._s(e.purchase_number))]
                            ),
                            _vm._v(")"),
                          ])
                        : _c("span", [
                            _vm._v(
                              "(Закупка: " + _vm._s(e.purchase_number) + ")"
                            ),
                          ]),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }